import {
    GET_CHART_OF_ACCOUNT_ERROR, GET_CHART_OF_ACCOUNT_SUCCESS, GET_CHART_OF_ACCOUNT_REQUEST,
    ADD_CHART_OF_ACCOUNT_REQUEST, ADD_CHART_OF_ACCOUNT_SUCCESS, ADD_CHART_OF_ACCOUNT_ERROR,
    UPDATE_CHART_OF_ACCOUNT_ERROR, UPDATE_CHART_OF_ACCOUNT_SUCCESS, UPDATE_CHART_OF_ACCOUNT_REQUEST,
    DELETE_CHART_OF_ACCOUNT_ERROR, DELETE_CHART_OF_ACCOUNT_REQUEST, DELETE_CHART_OF_ACCOUNT_SUCCESS,
    GET_ALL_CHART_OF_SUB_ACCOUNT_REQUEST,
    GET_ALL_CHART_OF_SUB_ACCOUNT_SUCCESS,
    GET_ALL_CHART_OF_SUB_ACCOUNT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js"





export const getChartofAccount = (token, id) => (dispatch) => {
    dispatch({ type: GET_CHART_OF_ACCOUNT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/account`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { id }
    })
        .then((response) => {
            return dispatch({ type: GET_CHART_OF_ACCOUNT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_CHART_OF_ACCOUNT_ERROR,
                payload: error.response,
            });
        });
};

export const addChartofAccount = (token, data) => (dispatch) => {
    dispatch({ type: ADD_CHART_OF_ACCOUNT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/account`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {

            return dispatch({ type: ADD_CHART_OF_ACCOUNT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_CHART_OF_ACCOUNT_ERROR,
                payload: error.response,
            });
        });
};


export const updateChartofAccount = (token, data, id) => (dispatch) => {

    dispatch({ type: UPDATE_CHART_OF_ACCOUNT_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/account/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {

            return dispatch({ type: UPDATE_CHART_OF_ACCOUNT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_CHART_OF_ACCOUNT_ERROR,
                payload: error.response,
            });
        });
};



export const deleteChartofAccount = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_CHART_OF_ACCOUNT_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/account/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_CHART_OF_ACCOUNT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_CHART_OF_ACCOUNT_ERROR,
                payload: error.response,
            });
        });
};



export const chartOfSubAccount = (token, id) => (dispatch) => {
    dispatch({ type: GET_ALL_CHART_OF_SUB_ACCOUNT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/ChartOfAccountSubAccount`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: GET_ALL_CHART_OF_SUB_ACCOUNT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ALL_CHART_OF_SUB_ACCOUNT_ERROR,
                payload: error.response,
            });
        });
};
